<a class="{{classes}}" (click)="onCallClick()">Call</a>
<a *ngIf="from == 'restaurant'" class="{{classes}}" (click)="onEmailClick()">Email</a>
<a *ngIf="from == 'restaurant'" class="{{classes}}" (click)="onShareRestClick()">Share</a>
<a class="{{classes}}" (click)="openGoogleMaps()">Directions</a>
<a *ngIf="from == 'receipt'" class="{{classes}}" (click)="onFeedback()">Feedback</a>
